/* src/app/shared/services/dialog/notify-dialog/notify-dialog.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.notify-dialog {
  font-size: 1rem;
  position: relative;
  width: 26.875rem;
}
.notify-dialog .close-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: none;
  outline: none;
}
.notify-dialog .close-button.cdk-focused.cdk-keyboard-focused {
  border: none;
  outline: none;
  background: none;
}
.notify-dialog .mat-mdc-dialog-title {
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 1rem 3.2rem 0 3.2rem;
  margin-bottom: 0.3rem;
}
.notify-dialog .mat-mdc-dialog-content {
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0 3.2rem 1.25rem;
}
.notify-dialog .mat-mdc-dialog-content p {
  font-size: 1em;
  margin-bottom: 1rem;
}
/*# sourceMappingURL=notify-dialog.component.css.map */
